module.exports = __webpack_public_path__ + "img/wallet.fd82e858.png";